import { Box, Loader } from '@wix/design-system';
import React from 'react';
export const PanelLoader = () => {
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    height: "100%",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(Loader, null));
};
//# sourceMappingURL=panel-loader.js.map